import { googleCalendarConstants } from '../constants';

export const googleCalendar = (state = {}, action) => {
  switch (action.type) {
    case googleCalendarConstants.LOGIN_REQUEST:
      return {
        ...state,
       };
    case googleCalendarConstants.LOGIN_SUCCESS:
      return {
        ...state,
       };
    case googleCalendarConstants.LOGIN_FAILURE:
      return {
        ...state,
        error: action.error,
       };
    case googleCalendarConstants.REDIRECT_REQUEST:
      return {
        ...state,
      };
    case googleCalendarConstants.REDIRECT_SUCCESS:
      return {
        ...state,
      };
    case googleCalendarConstants.REDIRECT_FAILURE:
      return {
        ...state,
        error: action.error,
      };
    case googleCalendarConstants.CREATE_REQUEST:
      return {
        ...state,
      };
    case googleCalendarConstants.CREATE_SUCCESS:
      return {
        ...state,
      };
    case googleCalendarConstants.CREATE_FAILURE:
      return {
        ...state,
        error: action.error,
      };
    case googleCalendarConstants.GET_REQUEST:
      return {
        ...state,
      };
    case googleCalendarConstants.GET_SUCCESS:
      return {
        ...state,
        selectedEvent: action.event,
      };
    case googleCalendarConstants.GET_FAILURE:
      return {
        ...state,
        error: action.error,
      };
    case googleCalendarConstants.GET_ALL_REQUEST:
      return {
        ...state,
      };
    case googleCalendarConstants.GET_ALL_SUCCESS:
      return {
        ...state,
        allEvents: action.event
      };
    case googleCalendarConstants.GET_ALL_FAILURE:
      return {
        ...state,
        error: action.error,
      };
    case googleCalendarConstants.UPDATE_REQUEST:
      return {
        ...state,
      };
    case googleCalendarConstants.UPDATE_SUCCESS:
      return {
        ...state,
        selectedEvent: action.event,
      };
    case googleCalendarConstants.UPDATE_FAILURE:
      return {
        ...state,
        error: action.error,
      };
    case googleCalendarConstants.DELETE_REQUEST:
      return {
        ...state,
      };
    case googleCalendarConstants.DELETE_SUCCESS:
      return {
        ...state,
      };
    case googleCalendarConstants.DELETE_FAILURE:
      return {
        ...state,
        error: action.error,
      };
    case googleCalendarConstants.LOGOUT_REQUEST:
      return {
        ...state,
      };
    case googleCalendarConstants.LOGOUT_SUCCESS:
      return {
        ...state,
      };
    case googleCalendarConstants.LOGOUT_FAILURE:
      return {
        ...state,
        error: action.error,
      };
    default: return state
  }
};
